import { GobalHttpInterceptor } from './core/net/gobal.http.interceptors';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
 
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';
import { AppErrorHandler } from './core/services/app-error-handler';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StartupService } from './core/startup/startup.service';
import { NZ_I18N, zh_CN } from 'ng-zorro-antd/i18n';
import { SettingsService } from './core/services/settings.service';
import { ChatService } from './core/common/app-im/chat.service';
 
 
 
 
 

 // #程序启动服务
// export function StartupServiceFactory(
//   startupService: StartupService
// ): Function {
//   return () =>{
//     startupService.load();
//   };
 
// }
const APPINIT_PROVIDES = [
  StartupService,
  {
    provide: APP_INITIALIZER,
    useFactory:  (s1: SettingsService, startupService: StartupService) => async () => {
      startupService.load();
      //await chat.start();
      return s1.loadTheme(s1._defaultTheme);
    },
    deps: [SettingsService,StartupService,ChatService],
    multi: true,
  },
];

 
// 加载i18n语言文件
export function I18nHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `./assets/tmp/i18n/`, '.json');
}
const I18NSERVICE_MODULES = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: I18nHttpLoaderFactory,
      deps: [HttpClient],
    },
  }),
];

registerLocaleData(zh);
//http拦截
const INTERCEPTOR_PROVIDES = [
  { provide: HTTP_INTERCEPTORS, useClass: GobalHttpInterceptor, multi: true }
];
@NgModule({
  declarations: [
    AppComponent
 
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    LayoutModule,
    AppRoutingModule,
    IconsProviderModule,
    ...I18NSERVICE_MODULES
  ],
  providers: [
    { provide: NZ_I18N, useValue: zh_CN },
    { provide: ErrorHandler, useClass: AppErrorHandler },
     ...INTERCEPTOR_PROVIDES,
     ...APPINIT_PROVIDES
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
